import { createSelector } from 'reselect'

const getUserLogged = state => state.user.logged
const user_logged_selector = createSelector(
	[ getUserLogged ],
	userLogged => userLogged
)

export default user_logged_selector
